/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import { isEmpty } from 'lodash';
import { Row, Col, Container } from 'react-bootstrap';
import Carousel from 'react-multi-carousel';
import { Spinner } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
//ui
import { AiOutlineTwitter } from 'react-icons/ai';
import { GrFacebookOption } from 'react-icons/gr';
import { BiCheckCircle } from 'react-icons/bi';
import { FaRegTimesCircle, FaShippingFast } from 'react-icons/fa';
import { HiMail } from 'react-icons/hi';
//api
import { getDetailProduct, getRelatedProduct } from 'api/products';
import { getBookDetail, getBookAvailableLibraries } from 'api/libros';
import { addItemCart } from 'api/ecommerce';
import { saveFavoriteProductUser, deleteFavoriteProductUser } from 'api/users';
//slices
import { addItem } from 'slices/cart';
import { userSelector } from 'slices/user';
import { companySelector } from 'slices/company.js';
//helpers
import { truncate, checkEmpty, capitalize } from '../../helpers';
//utils
import { cleanHTML } from '../../utils';
import { formatCurrency } from 'utils/currencyFormatter';
// CONSTANTS
import { responsive } from '../../constants';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
// components
import CoverImage from 'components/coverImage/CoverImage';
import ItemList from 'components/itemList/item';
import AvailableLibraries from 'components/availableLibraries';
import Head from 'components/metatags_helmet/metatags';
import Authors from 'components/authors';
import NoResults from 'components/userzone/NoResults';
import Button from 'components/userzone/buttons/ButtonCustom';
//styles
import 'react-multi-carousel/lib/styles.css';
//images
import imageAvailableBook from 'assets/img/booktores_available.png';

function BookDetail() {
  const { t } = useTranslation(['detalle']);
  const dispatch = useDispatch();
  const { isLogged } = useSelector(userSelector);
  const [productDetail, setProductDetail] = useState('');
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [isBookFavorited, setIsBookFavorited] = useState({ status: false, id: null });
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [fullDescription, setFullDescription] = useState(false);
  const [restockSubscriptionStatus, setRestockSuscriptionStatus] = useState(null);
  const [availableLibraries, setAvailableLibraries] = useState([]);
  const [showAvailableBookstores, setShowAvailableBookstores] = useState(false);
  const [loadingRelatedProducts, setLoadingRelatedProducts] = useState(true);
  const [noResults, setNoResults] = useState(false);
  const [loading, setLoading] = useState(false);
  const { assignedLibrary } = useAssignedLibrary();

  const shareUrl = window.location.href;
  let { id } = useParams();
  const { pathname } = useLocation();
  const { name } = useSelector(companySelector);

  useEffect(() => {
    window.scrollTo(0, 0);
    const type = pathname.split('/')[2];
    handleDetailProduct(type);
    handleRelatedProducts();
  }, [id]);

  useEffect(() => {
    const getAvailableBookstores = async () => {
      try {
        const { status, data } = await getBookAvailableLibraries(id);
        if (status === 200) {
          setAvailableLibraries(data);
        }
      } catch (error) {
        console.error(error);
      }
    }
    if (showAvailableBookstores) getAvailableBookstores();
  }, [showAvailableBookstores])

  const properties = {
    processLan() {
      if (!productDetail.languages) return null;
      const lans = productDetail.languages
        .map((val, i) => {
          return val.nombre;
        })
        .join(',');
      return lans.length >= 1 ? lans : 'N/A';
    },
    processEncuadernacion(product) {
      if (!product.encuadernacion) return null;
      const bookBinding = product.encuadernacion
        .map((val, i) => {
          return `${val.descripcion}`;
        })
        .join(',');
      return bookBinding;
    },
  };

  const checkDetailEpCallByType = (type) => {
    if (type === 'libro') {
      return getBookDetail(id);
    } else {
      return getDetailProduct(id);
    }
  };

  const handleSEOTitle = (type, title) => {
    if (type === 'merchandising') {
      return `merchandising ${title}`;
    } else if (type === 'film') {
      return `${t('movie')} ${title}`;
    } else {
      return `${title}| ${t('buybook')}`;
    }
  };

  const handleSEODescription = (data) => {
    if (data.type === 'film') {
      const editorial = data.editorial ? data.editorial.nombre_fiscal : '';
      return `${t('themovie')} ${data.title} ${t('ofthestudy')} ${editorial}, ${t('saleonline')} ${name}.`;
    } else if (data.type === 'merchandising') {
      return `${t('fanof')} ${title}, ${t('in')} ${name} ${t('merchadisingproducts')}`;
    } else {
      const autor = data?.authors[0] ? data?.authors[0].nombre_autor : '';
      return `${t('thebook')} ${data.title} ${t('oftheauthor')} ${autor} ${t('with')} EAN ${data.ean}, ${t('saleonline')} ${name}.`;
    }
  };

  const handleDetailProduct = async (type) => {
    try {
      const { status, data } = await checkDetailEpCallByType(type);
      if (status === 200) {
        setIsBookFavorited({ status: data?.saved.favorite, id: data?.saved.id || null });
        setProductDetail(data);
        setTitle(handleSEOTitle(data?.type, data?.title));
        setDescription(handleSEODescription(data));
      } else {
        setNoResults(true);
      }
    } catch (error) {
      console.error('%c -handleDetailProduct- ERROR', error);
    }
  };

  const handleRelatedProducts = async () => {
    const fields = ['id', 'title', 'url', 'image', 'authors', 'type', 'price', 'has_stock', 'encuadernacion'].join(',');
    try {
      const { status, data } = await getRelatedProduct(id, { fields: fields });
      if (status === 200) {
        setRelatedProducts(data);
      }
    } catch (error) {
      console.error('%c -handleRelatedProducts- ERROR', error);
    } finally {
      setLoadingRelatedProducts(false);
    }
  };

  const addBookToFavoritesHandler = async () => {
    const { status, data } = await saveFavoriteProductUser({ product: productDetail.id });
    if ([200, 201].includes(status)) {
      setIsBookFavorited((prevState) => ({
        ...prevState,
        status: true,
        id: data?.id,
      }));
    }
  };
  const removeBookFromFavoritesHandler = async () => {
    const { status } = await deleteFavoriteProductUser(isBookFavorited.id);
    if (status === 204) {
      setIsBookFavorited({ status: false, id: null });
    }
  };

  const addProductToCart = async (data) => {
    if (isLogged) {
      setLoading(true);
      const payload = { item: data.id, quantity: 1 };
      const { status } = await addItemCart(payload);
      if (status === 201) {
        dispatch(addItem(data));
      } else {
        console.log('error');
      }
    } else {
      dispatch(addItem(data));
    }
    setLoading(false);
  };

  useEffect(() => {    //!   PARA QUE ES? -REVISAR-
    setRestockSuscriptionStatus(undefined);
  }, [productDetail]); //selectedItem

  const closeOverlay = () => {
    setShowAvailableBookstores(!showAvailableBookstores);
  };

  return (
    <div className="container-fluid justify-content-center pt-5 overflow-hidden mainDiv">
      <Head description={description} title={title} />
      {!noResults ? (
        <Container fluid className="justify-content-center px-0">
          <Row className="justify-content-center px-0">
            <Col lg={9} className="pl-3">
              <Row className="px-0">
                <Col md={4} lg={4} className="mb-2">
                  <div className="d-flex">
                    {!isEmpty(productDetail) &&
                      <CoverImage title={productDetail.title} src={productDetail.image} />}
                    {productDetail?.is_novelty && (
                      <div className="markers-ficha markers-ficha-detail d-flex">
                        <p className="markers-novelty mx-2 py-2">{t('novelty')}</p>
                      </div>
                    )}
                  </div>
                  <div className="socialDiv">
                    <p>{t('compartir')}: </p>
                    <a
                      href={`https://facebook.com/sharer/sharer.php?u=${shareUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div className="icon">
                        <GrFacebookOption />
                      </div>
                    </a>
                    <a
                      href={`https://twitter.com/intent/tweet?text=Libro%20recomendado%3A%0A${shareUrl}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div className="icon">
                        <AiOutlineTwitter />
                      </div>
                    </a>
                    <div className="icon">
                      <HiMail />
                    </div>
                  </div>
                </Col>
                <Col md={6} lg={8} className="pl-3">
                  <div className="description-matters">
                    {
                      productDetail?.materia_ibic?.length > 0 && productDetail?.materia_ibic.map((item, i) => (
                        <div key={i} >
                          <Link to={`/${assignedLibrary}/lista/materias?title=${item.descripcion}`} state={item.id} >
                            {capitalize(item?.descripcion)}
                          </Link>
                        </div>
                      ))
                    }
                  </div>

                  <Row md={12} className="p-0">
                    <Col md={12}>
                      <h1 className="titleItem">{productDetail?.title}</h1>
                    </Col>
                  </Row>
                  <Row md={12}>
                    <Col md={12}>
                      <h3 className="autor-item mt-1 d-flex">
                        {productDetail?.authors && (
                          <Authors elements={productDetail?.authors} originDetail={pathname.includes('/libro/')} />
                        )}
                      </h3>
                    </Col>
                  </Row>

                  <Row md={12} className="description-item pt-3">
                    <Col md={12}>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: checkEmpty(productDetail)
                            ? fullDescription
                              ? cleanHTML(productDetail?.summary)
                              : truncate(cleanHTML(productDetail?.summary), 400)
                            : '',
                        }}
                      />
                    </Col>
                    {productDetail?.summary?.length > 400 && (
                      <Button
                        className="mb-3"
                        size="sm"
                        variant="link"
                        onClick={() => {
                          fullDescription ? setFullDescription(false) : setFullDescription(true);
                        }}
                      >
                        {fullDescription ? t('watchLess') : t('watchMore')}
                      </Button>
                    )}
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col lg={3} className="pr-2 buttonsCol">
              <Row>
                <Col
                  lg={12}
                  className="d-flex justify-content-end "
                >
                  <p className="mx-3">{productDetail.has_stock ? t('enStock') : t('sinStock')}</p>
                  {productDetail?.price && <span>{formatCurrency(productDetail.price)}</span>}
                </Col>
              </Row>
              <Row className="buttonRow">
                <Col lg={12} >
                  <Button className={`${!productDetail?.has_stock ? 'noStock' : 'inStock'} pe-none`}>
                    {properties.processEncuadernacion(productDetail) !== null &&
                      properties.processEncuadernacion(productDetail) !== ''
                      ? properties.processEncuadernacion(productDetail) + ' '
                      : 'Libro físico '}
                    {productDetail?.price && formatCurrency(productDetail.price)}
                    {productDetail.has_stock ? <BiCheckCircle /> : <FaRegTimesCircle />}
                  </Button>
                </Col>
              </Row>

              {productDetail?.has_stock && (
                <Row className="buttonRow">
                  <Col lg={12} className="">
                    <Button onClick={() => addProductToCart(productDetail)} className="mt-3 addCart" loading={loading}>
                      {t('anadirCesta')}
                    </Button>
                  </Col>
                </Row>
              )}
              <Row>
                {productDetail?.available && (
                  <Col lg={12} className="d-flex mt-1 shippingTime">
                    <p>
                      <FaShippingFast className="mx-2" />
                      {productDetail?.available?.text}
                    </p>
                  </Col>
                )}
              </Row>
              {
                productDetail?.has_stock && (
                  <Col lg={12} className="container-available-book">
                    <img src={imageAvailableBook} alt="Bookstore available" className="image-available-book" />
                    <div className="available-book" onClick={() => setShowAvailableBookstores(!showAvailableBookstores)}>
                      {t('bookstorefindit')}
                    </div>
                  </Col>
                )
              }
              <Row>
                {isLogged && (
                  <Col lg={12} className="my-2 d-flex justify-content-center">
                    <Button
                      className={`text-uppercase product-${isBookFavorited?.status ? 'favorited' : 'no-favorited'}`}
                      onClick={isBookFavorited?.status ? removeBookFromFavoritesHandler : addBookToFavoritesHandler}
                    >
                      {isBookFavorited?.status ? t('eliminarFavoritos') : t('anadirFavoritos')}
                    </Button>
                  </Col>
                )}
              </Row>
              <Row className="mt-4 mx-1 detailRow">
                <p>{t('datosProducto')}</p>
                <ul>
                  {productDetail?.editorial ? (
                    <li>
                      <strong>{t('editorial')}: </strong>
                      <Link className="store-item__link" to={`/${assignedLibrary}/editorial/${productDetail?.editorial.url}/`} state={productDetail?.editorial.id}>
                        {productDetail.editorial.nombre_fiscal}
                      </Link>
                    </li>
                  ) : (
                    <p>
                      <strong>{t('editorial')}: </strong>
                      <span>{t('notSpecified')}</span>
                    </p>
                  )}
                  {productDetail?.ean && (
                    <li>
                      <strong>ISBN:</strong> <span className="text-datosProducto">{productDetail.ean}</span>
                    </li>
                  )}
                  {productDetail?.publication_date && (
                    <li>
                      <strong>{t('publicacion')}:</strong> <span className="text-datosProducto">{productDetail.publication_date}</span>
                    </li>
                  )}
                  {productDetail?.encuadernacion && (
                    <li>
                      <strong>{t('formato')}:</strong> <span className="text-datosProducto">{properties.processEncuadernacion(productDetail)}</span>
                    </li>
                  )}
                  {productDetail?.languages && (
                    <li>
                      <strong>{t('idioma')}:</strong> <span className="text-datosProducto">{properties.processLan()}</span>
                    </li>
                  )}
                  {productDetail?.alto_cm && productDetail?.ancho_cm && productDetail?.grosor_cm && (
                    <li>
                      <strong>{t('dimensions')}:</strong>{' '}
                      <span className="text-datosProducto">
                        {`${productDetail?.alto_cm}cm x ${productDetail?.ancho_cm}cm x ${productDetail?.grosor_cm}cm`}
                      </span>
                    </li>
                  )}
                  {productDetail?.num_paginas && (
                    <li>
                      <strong>{t('numeroPagina')}:</strong> <span className="text-datosProducto">{productDetail.num_paginas}</span>
                    </li>
                  )}
                </ul>
              </Row>
            </Col>
          </Row>
          <Row className="justify-content-center mt-4">
            <Col lg={11} className="w-100">
              {loadingRelatedProducts && !noResults ? (
                <div className="d-flex justify-content-center align-items-center">
                  <Spinner animation="border" role="status" />
                </div>
              ) : relatedProducts.length > 0 ? ( // Mostrar productos relacionados si están disponibles
                <section className="list-section">
                  <Row className="mb-4">
                    <Col xs={12} sm={12} className="px-0">
                      <h3>{t('otrosProductos')}</h3>
                    </Col>
                  </Row>
                  <Col xs={12} sm={12}>
                    <Carousel
                      responsive={responsive}
                      slidesToSlide={1}
                      minimumTouchDrag={40}
                      draggable
                      swipeable
                    >
                      {relatedProducts?.map((item, i) => (
                        <div key={`relatedProductsItem#${i}`} className="slide-div">
                          <ItemList data={item} />
                        </div>
                      ))}
                    </Carousel>
                  </Col>
                </section>
              ) : null}
            </Col>
          </Row>
          <AvailableLibraries
            hasStock={productDetail?.has_stock}
            showLibraries={showAvailableBookstores}
            closeOverlay={closeOverlay}
            libraries={availableLibraries}
          />
        </Container>
      ) : (
        <NoResults className='noFavorites' />
      )}
    </div>
  );
}

export default BookDetail;
